<template>
  <div id="maintenanceMessage" class="has-background-warning" v-show="maintenance.message">
    <p><i class="fas fa-exclamation-triangle"></i>&nbsp;&nbsp;&nbsp;{{ maintenance.message}}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      maintenance: 'http/maintenance'
    })
  }
}
</script>

<style lang="css" scoped>
  #maintenanceMessage {
    margin: -30px 0 30px;
    padding: 5px 15px;
  }
</style>
